import type { FunctionComponent } from 'react';
import { EulaTextEn } from './EulaTextEn';

export const EulaText: FunctionComponent = () => {
  return <EulaTextEn />;
};
